/* ─── CatalogSkeleton.tsx ─── */

const TITLE_WIDTHS = [65, 75, 85];

interface CatalogSkeletonProps {
  count?: number;
}

export function CatalogSkeleton({ count = 6 }: CatalogSkeletonProps) {
  return (
    <>
      <style>{`
        @keyframes skeletonPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        .skeleton-box {
          background: #e2e8f0;
          border-radius: 6px;
          animation: skeletonPulse 1.5s ease-in-out infinite;
        }
      `}</style>

      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "13px 15px",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          {/* Conteúdo esquerdo */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 8 }}>
            {/* Título */}
            <div
              className="skeleton-box"
              style={{
                height: 14,
                width: `${TITLE_WIDTHS[i % TITLE_WIDTHS.length]}%`,
                animationDelay: `${i * 0.08}s`,
              }}
            />

            {/* Badge SKU */}
            <div
              className="skeleton-box"
              style={{
                height: 18,
                width: 100,
                borderRadius: 20,
                animationDelay: `${i * 0.08 + 0.1}s`,
              }}
            />

            {/* Tags: uso · segmento · série */}
            <div style={{ display: "flex", gap: 6 }}>
              {[50, 70, 55].map((w, j) => (
                <div
                  key={j}
                  className="skeleton-box"
                  style={{
                    height: 18,
                    width: w,
                    borderRadius: 20,
                    animationDelay: `${i * 0.08 + j * 0.05 + 0.15}s`,
                  }}
                />
              ))}
            </div>

            {/* Linha de preço */}
            <div
              className="skeleton-box"
              style={{
                height: 12,
                width: 90,
                animationDelay: `${i * 0.08 + 0.25}s`,
              }}
            />
          </div>

          {/* Botão "+ Selecionar" */}
          <div
            className="skeleton-box"
            style={{
              height: 32,
              width: 90,
              borderRadius: 8,
              flexShrink: 0,
              animationDelay: `${i * 0.08 + 0.2}s`,
            }}
          />
        </div>
      ))}
    </>
  );
}
